import React from 'react';

export const Star: React.FC = () => (
    <svg
        width="38"
        height="34"
        viewBox="0 0 38 34"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M7.28431 33.7453C7.92848 34.1854 8.70684 34.0471 9.65966 33.3933L19 26.9812L28.3403 33.3933C29.2932 34.0471 30.0849 34.1854 30.7157 33.7453C31.333 33.3053 31.4806 32.576 31.1049 31.5199L27.4412 21.2354L36.8486 14.8987C37.8015 14.2575 38.1772 13.5912 37.9222 12.8871C37.6807 12.2082 36.9828 11.8435 35.775 11.8561L24.2338 11.919L20.7043 1.59674C20.342 0.528056 19.7784 0 19 0C18.2216 0 17.658 0.528056 17.2957 1.59674L13.7662 11.919L2.22496 11.8561C1.03058 11.8435 0.319318 12.2082 0.0777571 12.8871C-0.177224 13.5912 0.198537 14.2575 1.15136 14.8987L10.5588 21.2354L6.90855 31.5199C6.51937 32.576 6.66699 33.3053 7.28431 33.7453Z" />
    </svg>
);
